export const DISPLAY_DATE_FORMAT = 'd MMM'
export const FUSION_DATE_FORMAT = 'dd-MM-yyyy'
export const NUM_OF_USP_TO_SHOW = 3
export const PETS_STAY_FREE_ID = '6554'
export const PRICE_FROM_NIGHTS = 7
export const PROPERTY_CALLOUT_BADGE_ID = '10638'
export const RESULTS_PAGE_SIZE = 12
export const SUMMARIES_API_TIMEOUT = 5000
export const DEFAULT_PAGE_NUMBER = 1
export const OPTIMIZELY_DATAFILE_CACHE_TTL = 60000 * 5 // 5 minutes
export const CONTENTFUL_CACHE_TTL = 60000 // 1 minute
export const CLOUDFRONT_WAF_BOT_CATEGORY_HEADER = 'x-amzn-waf-bot-category'
export const APP_OPTIMIZELY_ID_HEADER_NAME = 'x-awaze-app-optimizely-id'
export const APP_CORRELATION_ID_HEADER_NAME = 'x-awaze-app-correlation-id'

export const APP_CLIENT_ID = 'search-mfe'

export const ALLOWED_GRADES = ['2', '3', '4', '5', 'P']

export const GRADE_CAT_IDS = {
  2: 'gradetwo',
  3: 'gradethree',
  4: 'gradefour',
  5: 'gradefive',
} as const

export const DEFAULT_SEARCH_LOCATION_URL = '/all-regions'

export const IMAGE_DOMAIN_NOVASOL = 'https://image.novasol.com'
export const IMAGE_DOMAIN_BASE_URL = 'https://img.chooseacottage.co.uk/Property'
export const IMAGE_WIDTH_AWAZE = 640
export const IMAGE_WIDTH_NOVASOL = 600

export const DEFAULT_IMAGE_URL =
  'https://img.chooseacottage.co.uk/Property/notFoundImage.png'

export const MAX_AUTOCOMPLETE_RESULTS = 100

export const DEFAULT_MAX_LEVEL_MAP_ZOOM = 16

export const CORRELATION_ID_COOKIE_NAME = 'awaze_correlation_id'

export const CORRELATION_ID_NOT_FOUND_REPLACEMENT =
  'NO_CORRELATION_ID_IN_COOKIE'

export const HOUR_TO_ALLOW_MAU_GENERATION_FROM = 5

export const COUNTRY_CODE_TO_TIMEZONE = {
  GB: 'Europe/London',
  DE: 'Europe/Berlin',
  FR: 'Europe/Paris',
  NL: 'Europe/Amsterdam',
  ES: 'Europe/Madrid',
  IT: 'Europe/Rome',
  NO: 'Europe/Oslo',
  SE: 'Europe/Stockholm',
  DK: 'Europe/Copenhagen',
  PL: 'Europe/Warsaw',
  HR: 'Europe/Zagreb',
}

export enum OPTIMIZELY_FLAGS_ENUM {
  AGE_ACQUISITION_GOOGLE_FALLBACK_HOS = 'age_acquisition_autocomplete_google_fallback_methods_hos',
  AGE_ACQUISITION_GOOGLE_FALLBACK_NOV = 'age_acquisition_autocomplete_google_fallback_methods_nov',
  AGE_COUNTDOWN_BANNER = 'search_explore_search_pdp_age-2693_uk_jan_2025_sale_banner',
  DRIVE_TIME_SEARCH = 'guest_discovery___drivetime',
  APB_4017_WISHLIST_ENTRY_POINTS = 'guest_engagement_wishlist_v2',
  ONESEARCH_POPULAR_FEATURES = 'onesearch_popular_features',
  SALES_MERCH_PODS = 'guest_discovery_sales_merchandising_pods',
  GD_PROPERTY_CARD_V2 = 'guest_discovery_v2_property_card',
  GTM_GOOGLE_GATEWAY_PHASE_2 = 'gtm_google_gateway_phase_2',
  GD_AA = 'guest_discovery_a_a',
  ALPHABETICALLY_ORDERED_FILTERS = 'guest_discovery_gd-462_alphabetically_ordered_filters',
  REMOVE_POPULAR_DESTINATION_FILTER = 'gd_remove_popular_destination_filter',
  ONESEARCH_NEW_PROPERTIES_BRAIDING = 'onesearch_new_properties_braiding',
  SEARCH_SUGGESTIONS_REST_API = 'search___search_suggestions_rest_api',
  ONESEARCH_NOVASOL_AGGRESSIVE_NR1_SORT = 'onesearch_novasol_aggressive_nr1_sort',
  ONESEARCH_COTTAGES_AGGRESSIVE_NR1_SORT = 'onesearch_cottages_aggressive_nr1_sort',
  FILTER_CATEGORIES = 'search_categorized_filters',
  WAS_NOW_PRICE_REMOVAL = 'search_was_now_price_removal',
}

export const AGE_ACQUISITION_SEARCH_FORM_NEW_DESTINATION_LIST =
  'age_acquisition_search_form_new_destination_list'
export const OPTIMIZELY_FLAGS = Object.values(OPTIMIZELY_FLAGS_ENUM)

export const OPTIMIZELY_VARIANT_KEYS = {
  SHOW_WITH_MEGA_MENU: 'show_with_mega_menu',
  GOOGLE_FALLBACK_AUTOCOMPLETE: 'autocomplete_fallback',
  GOOGLE_FALLBACK_TEXTSEARCH: 'textsearch_fallback',
}

export const OPTIMIZELY_EVENTS = {
  PDP_CLICK_THROUGH: 'age_search_pdp_click_through',
  DATED_SEARCH: 'age_search_dated_search',
  UNDATED_SEARCH: 'age_search_undated_search',
  POPULAR_FEATURE_CLICK: 'age_search_popular_feature_interaction',
  FEATURE_CLICK: 'age_search_feature_interaction',
  NO_RESULTS: 'age_search_no_results',
  MAP_CLICK: 'age_guest_discovery_map_interaction',
  NEARBY_PROPERTIES_GEOLOCATION_ACCESS_DENIED:
    'search_form___near_by_properties___geolocation_access_denied',
  NEARBY_PROPERTIES_GEOLOCATION_ERROR:
    'search_form___near_by_properties___geolocation_error',
  NEARBY_PROPERTIES_SEARCH_FORM_SUBMITTED:
    'search_form___near_by_properties___search_submitted',
  NEARBY_PROPERTIES_SEEN: 'search_form___near_by_properties___seen',
  SEARCH_FORM_SUBMITTED: 'search_form_submitted',
  MERCH_POD_CLICK: 'gd_marketing_banner_click',
  INTERNAL_LOCATION_SUGGESTION_SHOWN:
    'age_search_internal_location_suggestion_shown',
  INTERNAL_LOCATION_SUGGESTION_NO_RESULTS:
    'age_search_internal_location_suggestion_no_results',
  INTERNAL_LOCATION_SUGGESTION_SELECTED:
    'age_search_internal_location_suggestion_selected',
}

export const DEFAULT_MAX_STAY_DURATION = 365
export const UK_MAX_STAY_DURATION = 28
export const DEFAULT_RADIUS_KM = 10
export const GD_482_RADIUS_KM = 100
export const DRIVE_TIME_EXTENDED_RADIUS_KM = 300

export const SORT_OPTIONS_ENUM = {
  RECOMMENDED: 'recommended',
  PRICE_ASCENDING: 'priceasc',
  PRICE_DESCENDING: 'pricedsc',
  SLEEPS_ASCENDING: 'sleepsasc',
  SLEEPS_DESCENDING: 'sleepsdsc',
  REVIEWS_DESCENDING: 'reviewsdsc',
  NO_SORT: 'nosort',
}

export const MIMECAST_SCRIPT_HOSEASONS =
  'https://static.srcspot.com/libs/prisca.js'

export const MIMECAST_SCRIPT_COTTAGES =
  'https://static.srcspot.com/libs/kelsey.js'

export const MIMECAST_SCRIPT_NOVASOL = 'https://static.srcspot.com/libs/maye.js'
